import React from 'react'
import Autocomplete from '@material-ui/lab/Autocomplete'
import TextField from '@material-ui/core/TextField'


export default class PartnerTypes extends React.Component {
    state = {
        partnerTypes: ['DATA_PROVIDER', 'SELLER', 'MARKETER', 'PUBLISHER'],
        partnerTypesSelected: [],
    }

    componentDidMount() {
        //console.log('types props: ', this.props)
    }

    onPartnerTypeChange(partnerTypes) {
        console.log("onPartnerTypeChange", partnerTypes)
        let partnerTypesSelected = this.state.partnerTypesSelected
        console.log("partnerTypesSelected", partnerTypesSelected)
        partnerTypesSelected = partnerTypes
        
        this.setState({ partnerTypesSelected: partnerTypesSelected }, () => {
            // notify change on client
            this.props.onPartnerTypeChange(partnerTypes)
        })
    }

    render() {
        return (
            <div className="row">
                <div className="col-12">
                    <div>
                        
                        <Autocomplete
                            multiple
                            size="small"
                            defaultValue={this.props.partnerTypes}
                            limitTags={1}
                            id={'partner-type-select-' + new Date().getTime()}

                            
                            options={this.state.partnerTypes}
                            autoHighlight
                            getOptionLabel={option => option}
                            onChange={(event, newValue) => {
                                if (newValue) {
                                    this.onPartnerTypeChange(newValue)
                                }
                            }}
                            renderOption={option => (
                                <React.Fragment>
                                    {option}
                                </React.Fragment>
                            )}
                            renderInput={params => (
                                <TextField
                                    {...params}
                                    label="Partner type enabled"
                                    variant="outlined"
                                    inputProps={{
                                        ...params.inputProps,
                                        autoComplete: 'new-password', // disable autocomplete and autofill
                                        form: {
                                            autocomplete: 'off'
                                        }
                                    }}
                                />
                            )}
                        />
                    
                    </div>
                </div>
                
            </div>
        )
    }
}
